import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ToggleRemoteService {
  constructor(private httpClient: HttpClient) {}

  async asyncToggleList() {
    return this.httpClient
      .get(environment.serverUrlSalaryLoans + "features/all")
      .toPromise();
  }
}
